<div class="album py-5 bg-light">
    <div class="container">

        <ng-container *ngIf="itemCount == 0">
            <h2>Portfolio</h2>

            <p>
                The portfolio shows some images of various jobs we have undertaken to give you a flavour of what Jon Ray Building Ltd can do. 
                It is hopefully indicative of the high quality of work the company seeks to provide to all its clients. 
            </p>  

            <h4 *ngIf="selectedCat">{{selectedCat?.name}}</h4>

        </ng-container>
       
        <div *ngIf="id == 0" class="row">
            <div class="col-md-4" *ngFor="let item of getCategories()">
                <div class="card mb-4 shadow-sm">
                    <div class="card-image">
                        <img src="/assets/images/Portfolio/{{item.image}}.jpg" class="card-img-top"alt="{{item.name}} portfolio">
                    </div>
                    <div class="card-body">
                        <h5 class="card-title">{{item.name}}</h5>
                        <p *ngIf="showText" class="card-text">{{item.text}}</p>
                        <div class="d-flex justify-content-between align-items-center">
                            <div class="btn-group">
                                <a class="btn btn-sm btn-outline-secondary" href="/portfolio/{{item.id}}" role="button">View</a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div><!-- end row class -->

        <app-carousel [catId]=id></app-carousel>

    </div>
</div>
